import { put, takeEvery } from 'redux-saga/effects';
import Actions from '../per-employee-action';

export function* perEmployeesService() {
	try {
		// Department API removed - HR module requires subscription check
		yield put(Actions.creators.getPerEmployeeSuccess([]));
	} catch (err) {
		yield put(Actions.creators.getPerEmployeeFail(err));
	}
}

export default function* salaryperEmployeeWatcher() {
	yield takeEvery(Actions.types.GET_PER_EMPLOYEE_START, perEmployeesService);
}
